<div class="column grow center-center">
  <div
    class="row align-items-center"
    [class.justify-space-between]="hasHeaderItems"
    [class.sticky-item]="isOverviewTabsComponent"
    style="width: 100%"
    >
    <div class="row align-items-center" [class.with-gap]="hasHeaderItems" [class.center-center]="!hasHeaderItems" style="width: 100%">
      <div class="align-items-center"><ng-content select="[leftTabHeaderItems]"></ng-content></div>
      <div
        class="row align-items-center"
        [style.width]="tabContainerWidth"
        [class.overview-tabs]="isOverviewTabsComponent"
        [class.tabs]="!isOverviewTabsComponent"
        >
        @for (tab of tabs; track tab) {
          <div
            class="item grow tab"
            [class.selected]="tab.isActive"
            [class.disabled]="tab.disabled"
            (click)="tabClicked(tab)"
            >
            <ng-container
              [ngTemplateOutlet]="isOverviewTabsComponent ? overviewLabelsTpl : defaultLabelsTpl"
              [ngTemplateOutletContext]="{ tab: tab }"
            ></ng-container>
          </div>
        }
      </div>
    </div>
    <div class="align-items-center"><ng-content select="[rightTabHeaderItems]"></ng-content></div>
  </div>
  <ng-content></ng-content>
</div>

<ng-template let-tab="tab" #defaultLabelsTpl>
  <div class="row grow center-center" [attr.tab-name] = "tab.label">
    {{ tab.label | translate }}
  </div>
</ng-template>

<ng-template let-tab="tab" #overviewLabelsTpl>
  <div class="row grow center-center">
    <i class="ri-icon menu-icon" [ngClass]="tab.icon"></i>
    {{ tab.label | translate }}
  </div>
</ng-template>
